class AutoclickBehaviorAbstract {
  constructor({ autoclick, behavior, delayClickthroughHandler }) {
    this._autoclick = autoclick;
    this._behavior = behavior;
    this.internalCount = 0;
    this.delayClickthroughHandler = delayClickthroughHandler;
    this.init();
  }

  /** Runs when the class is instantiated. */
  init() {}

  /**
   * Only relevant for types that count something like interactions.
   * @returns {number} - Minimum amount until enabling delayed clickthrough.
   */
  getBehaviorCount() {
    return this._behavior == null ? null : this._behavior.count;
  }

  getBehaviorType() {
    return this._behavior == null ? null : this._behavior.type;
  }

  /**
   * How long to delay clickthrough by.
   * @returns {number} - Delay value in milliseconds.
   */
  getBehaviorDelay() {
    return this._behavior == null ? null : this._behavior.delay;
  }

  isCountReached() {
    return this.getCurrentCount() >= this.getBehaviorCount();
  }

  getCurrentCount() {
    return this.internalCount;
  }

  setCurrentCount(n) {
    if (typeof n !== "number") {
      throw new Error(`n must be a number, got: ${n}`);
    }
    this.internalCount = n;
  }

  /** Triggers a delayed clickthrough event. */
  delayClickthrough(delay = this.getBehaviorDelay()) {
    if (!this.isCountReached()) return;

    this.delayClickthroughHandler(delay);
  }

  /**
   * Triggered by the InteractionMonitor class.
   */
  onInteraction(_) {}

  /**
   * Should trigger when the creative is "finished". Typically this is the moment
   * an endscreen will appear.
   */
  onCompleted() {}

  /**
   * Triggers when an "engagement" event occurs. Engagement must be fired by the
   * creative or a subcomponent thereof.
   */
  onEngagement() {}

  onHtmlLoaded() {}

  onViewable() {}

  onViewableChange(_) {}
}
export default AutoclickBehaviorAbstract;



// WEBPACK FOOTER //
// ./src/js/madlib/autoclick/AutoclickBehaviorAbstract.js